import { Component, effect } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ConsumptionHubService } from '../../services/consumption-hub.service';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-context-section',
  templateUrl: './context-section.component.html'
})
export class ContextSectionComponent {
  accountName = '–';
  partitionName = '–';
  dataPartitionId = '–';
  apiBaseUrl = '–';
  loading = false;
  fetchError = '';

  constructor(
    private auth: AuthService,
    private hub: ConsumptionHubService,
    private config: ConfigService
  ) {
    // Auto-fetch context whenever the user becomes authenticated
    effect(() => {
      if (this.auth.authenticated()) {
        this.fetchContext();
      } else {
        this.accountName = '–';
        this.partitionName = '–';
        this.dataPartitionId = '–';
        this.apiBaseUrl = '–';
        this.fetchError = '';
      }
    });
  }

  async fetchContext(): Promise<void> {
    this.loading = true;
    this.fetchError = '';
    try {
      const context = await this.hub.fetchUserContext();
      this.accountName = context?.account?.name || '–';
      this.partitionName = context?.dataPartition?.name || '–';
      this.dataPartitionId = context?.dataPartition?.dataPartitionId || '–';
      this.apiBaseUrl = this.config.consumptionHubInstance || '–';
    } catch (error: any) {
      console.error('Failed to fetch context:', error);
      this.fetchError = error?.message || 'Failed to fetch context.';
    } finally {
      this.loading = false;
    }
  }
}
